import { useEffect, useState } from 'react'
import { PropsWithChildren } from 'react'
import { mdiArrowUp } from '@mdi/js'
import Icon from '@mdi/react'
import { throttle } from 'lodash/fp'
import theme from 'theme_'

import { StyledCommonLayout, GoToTopContainer } from './styles'

const scrollContainer = () => {
  return document.documentElement || document.body
}

function CommonLayout(props: PropsWithChildren<{}>) {
  const [isToTopBtnVisible, setIsToTopBtnVisible] = useState(false)
  const isMobile = window.matchMedia(theme.devices.desktop)

  useEffect(() => {
    const onScrollHandler = throttle(100, () => {
      if (scrollContainer().scrollTop > 125) {
        setIsToTopBtnVisible(true)
      } else {
        setIsToTopBtnVisible(false)
      }
    })

    if (isMobile) {
      document.addEventListener('scroll', onScrollHandler)
    }

    return () => {
      document.removeEventListener('scroll', onScrollHandler)
    }
  }, [isMobile])

  return (
    <StyledCommonLayout>
      {props.children}

      <GoToTopContainer
        className={isToTopBtnVisible ? 'ToTopBtn--visible' : undefined}
        onClick={() => {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }}
      >
        <Icon path={mdiArrowUp} color={theme.colors.white} size={1} />
      </GoToTopContainer>
    </StyledCommonLayout>
  )
}

export default CommonLayout
